module.exports = __webpack_public_path__ + "static/media/krx-tutorial-01.8345c7e6.jpg";